import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import qs from 'qs';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { apiClientWithApi } from '../../utils/http';
import { blockNumbersParameters } from '../../hooks/components/BlockNumbers/constants';
import { BlockNumberItem } from '../../models/BlockNumbers/BlockNumbers';

export interface BlockNumbersState {
  items: BlockNumberItem[];
  totalItemsCount: number;
  status: Status;
}

export interface BlockNumbersResponse {
  items: BlockNumberItem[];
  totalItemsCount: number;
}

export interface BlockNumbersRequest {
  'Filter.From': string;
  'Filter.To': string;
  PageIndex: number;
  PageSize: number;
  SortKeySelector: string;
  'Filter.TextSearch': string;
  SortOrder: string;
}

const initialState: BlockNumbersState = {
  items: [],
  totalItemsCount: 0,
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export const getBlockNumbers = createAsyncThunk(
  'BlockNumbers/getBlockNumbers',
  async (request: BlockNumbersRequest, { rejectWithValue }) => {
    try {
      const response = await apiClientWithApi.get<BlockNumbersResponse>(
        'blackphone',
        {
          params: {
            [blockNumbersParameters['Filter.From']]: request['Filter.From'],
            [blockNumbersParameters['Filter.To']]: request['Filter.To'],
            [blockNumbersParameters.PageIndex]: request.PageIndex,
            [blockNumbersParameters.PageSize]: request.PageSize,
            [blockNumbersParameters.SortKeySelector]: request.SortKeySelector,
            [blockNumbersParameters['Filter.TextSearch']]:
              request['Filter.TextSearch'],
            [blockNumbersParameters.SortOrder]: request.SortOrder,
          },
          paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          },
        },
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else
        return rejectWithValue('Не удалось получить список исходящих звонков!');
    }
  },
);

export const blockNumbersSlice = createSlice({
  name: 'blockNumbers',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getBlockNumbers.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
        return state;
      })
      .addCase(getBlockNumbers.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        state.items = action.payload.items;
        state.totalItemsCount = action.payload.totalItemsCount;
        return state;
      })
      .addCase(getBlockNumbers.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось загрузить звонки';
        return state;
      });
  },
});

export default blockNumbersSlice.reducer;

export const selectBlockNumbers = (state: RootState) =>
  state.blockNumbers.items;

export const totalBlockNumbers = (state: RootState) =>
  state.blockNumbers.totalItemsCount;
